import { Button, Card, Input } from '@features/ui';
import { Controller, useForm } from 'react-hook-form';
import { ConvenienceFeeFormData } from '@src/types/feeSettings.ts';
import { useCallback, useEffect } from 'react';
import { getTaxAndFee, updateTaxAndFee } from '@src/services/taxAndFee';
import { toast } from 'react-toastify';

export const ConvenienceFee = () => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<ConvenienceFeeFormData>();

  const handleGetFeeData = async () => {
    try {
      const res = await getTaxAndFee();

      reset({
        paypal_convenience_fee:
          res.data.convenience_fee.paypal_convenience_fee * 100,
        stripe_convenience_fee:
          res.data.convenience_fee.stripe_convenience_fee * 100,
      });
    } catch (error) {
      console.error('Error fetching fee data:', error);
    }
  };

  const handleSubmitForm = useCallback(async (data: ConvenienceFeeFormData) => {
    try {
      await updateTaxAndFee({
        paypal_convenience_fee: data.paypal_convenience_fee,
        stripe_convenience_fee: data.stripe_convenience_fee,
      });
      toast.success('Fee data updated successfully');
    } catch (error) {
      toast.error('Failed to update fee data. Please try again.');
      console.error('Error updating fee data:', error);
    }
  }, []);

  useEffect(() => {
    handleGetFeeData();
  }, []);

  return (
    <form autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
      <h1 className={'text-[23px]'}>Convenience Fee</h1>
      <Card className={'text-xs mt-[18px]'}>
        <div
          className={
            'flex lg:w-[80%] lg:flex-row flex-col gap-x-[81px] gap-y-6'
          }
        >
          <Controller
            control={control}
            name="paypal_convenience_fee"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-2'}>
                <p>Paypal Convenience Fee (%)</p>
                <Input
                  error={!!errors?.paypal_convenience_fee?.message}
                  placeholder={'Enter'}
                  textSize={'xs'}
                  type={'number'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
          <Controller
            control={control}
            name="stripe_convenience_fee"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-2'}>
                <p>Stripe Convenience Fee (%)</p>
                <Input
                  error={!!errors?.stripe_convenience_fee?.message}
                  placeholder={'Enter'}
                  textSize={'xs'}
                  type={'number'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
        </div>
        <div className={'flex justify-end'}>
          <Button
            className={'mt-[40px] mb-[30px]'}
            loading={isSubmitting}
            size={'sm'}
            variant={'lime'}
          >
            Save
          </Button>
        </div>
      </Card>
    </form>
  );
};
